import { BeltBar } from "@/components/BeltBadge";

export const BELTS = ["white", "blue", "purple", "brown", "black"];
export const STYLES = [
  { v: "gi", l: "Gi" },
  { v: "nogi", l: "No-Gi" },
  { v: "both", l: "Both" },
];
export const GOALS = ["Compete", "Get better overall", "Fitness", "Self-defence", "Fun / hobby"];
export const FREQ = [1, 2, 3, 4, 5, 6, 7];

export function Label({ children, hint }) {
  return (
    <div className="mb-2.5 flex items-baseline justify-between">
      <span className="text-sm font-semibold text-white">{children}</span>
      {hint && <span className="text-xs text-[#71717A]">{hint}</span>}
    </div>
  );
}

export function ChoiceRow({ options, value, onChange, testid, className = "flex flex-wrap gap-2" }) {
  return (
    <div className={className}>
      {options.map((o) => {
        const v = typeof o === "object" ? o.v : o;
        const l = typeof o === "object" ? o.l : o;
        return (
          <button
            key={v}
            type="button"
            data-testid={`${testid}-${String(v).replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
            data-active={value === v}
            onClick={() => onChange(value === v && typeof v === "number" ? null : v)}
            className="choice"
          >
            {l}
          </button>
        );
      })}
    </div>
  );
}

export function BeltPicker({ belt, stripes, onChange }) {
  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 gap-2">
        {BELTS.map((b) => (
          <button
            key={b}
            type="button"
            data-testid={`belt-option-${b}`}
            data-active={belt === b}
            onClick={() => onChange({ belt: b, stripes })}
            className="choice h-14 flex items-center justify-between capitalize"
          >
            <span>{b}</span>
            <BeltBar belt={b} stripes={belt === b ? stripes : 0} className="w-24 h-4" />
          </button>
        ))}
      </div>
      <div>
        <Label>Stripes</Label>
        <ChoiceRow
          testid="stripes-option"
          options={[0, 1, 2, 3, 4].map((n) => ({ v: n, l: String(n) }))}
          value={stripes}
          onChange={(v) => onChange({ belt, stripes: v ?? 0 })}
          className="grid grid-cols-5 gap-2"
        />
      </div>
    </div>
  );
}
